import { TileDeFato } from "../componentes/CalendarioUi";
import { Cabine } from "../componentes/FerramentaUi";
import { FeedDeAlertas } from "../componentes/PeritoUi";
import type { Alerta } from "../lib/perito/alertas";

// Os alertas da Central do Perito (fase B), portados de `src/routes/_authenticated/alertas.tsx`: os prazos
// vencidos e perto de vencer, as tarefas atrasadas e os honorários vencidos, do mais antigo ao mais novo. A regra
// é `lib/perito/alertas.ts`, e a lista chega pronta do despacho, que é quem dá o número à barra das seções.

const RAIZ = "/ferramenta/central-do-perito";

export default function PeritoAlertas({ alertas }: { alertas: Alerta[] }) {
  const criticos = alertas.filter((a) => a.nivel === "critico").length;
  const atencao = alertas.filter((a) => a.nivel === "atencao").length;
  return (
    <div className="flex flex-col gap-5" data-alertas>
      <Cabine rotulo="Acompanhamento" titulo="Alertas"
        descricao="Os prazos vencidos ou perto de vencer, as tarefas atrasadas e os honorários vencidos. Cada alerta leva à perícia dele."
        fatos={criticos + atencao > 0 ? (
          <>
            {criticos > 0 && <TileDeFato rotulo="Críticos" valor={<span data-fato="criticos">{criticos}</span>} apoio="prazo vencido ou em até 3 dias" />}
            {atencao > 0 && <TileDeFato rotulo="Atenção" valor={<span data-fato="atencao">{atencao}</span>} apoio="prazo em até 7 dias, tarefa atrasada ou honorário vencido" />}
          </>
        ) : undefined} />
      <div className="surface max-w-4xl p-5 sm:p-6">
        <FeedDeAlertas raiz={RAIZ} alertas={alertas} />
      </div>
    </div>
  );
}
